import React, { Fragment } from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import { RecoilRoot } from "recoil";
import GQLUtil from "../../../global/utils/gqlHelper";
import ViewEntityQueryResolver from "../../../data/queries/profiles/profilesById/resolver";
import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";
import FormUISchemaResolver from "../../../data/schema/profiles/resolver";
import updateQueryBuilder from "./updateQueryBuilder";
import HelpfulTipsUIResolver from "../NewEntityModal/HelpfulTipModals/resolver";
import { withRouter } from "react-router-dom";
import ModalBox from "../../Form/components/ModalBox";
import mapperUtil from "../../Utils/mappers";

class EditEntityModal extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
      data: null,
      RedirectPage: false,
      formData: null, // resolved specifically to form
    };
  }

  async componentDidMount() {
    this.getData();
  }

  async componentWillMount() {
    mapperUtil
      .getCounties()
      .then((data) => this.setState({ counties: data }))
      .catch((e) => {
        console.log(`unable to fetch counties`);
      });
  }

  async getData() {
    const { id, formName } = this.props;

    let query = ViewEntityQueryResolver(formName, id);
    const data = await GQLUtil.genericGQLQuery(query);
    let retrieve = this.FormDataResolver(formName);

    this.setState({
      data: data.data,
      formData: data.data[retrieve.query][retrieve.formDataName],
    });
  }

  FormDataResolver = (formName) => {
    const graphqlnamelist = {
      employer: { query: "getEmployerById", formDataName: "EmployerFormData" },
      "employer-pocs": { query: "getPOCById", formDataName: "POCFormData" },
      "agent-attorney": {
        query: "getAgentProfileById",
        formDataName: "AgentProfileFormData",
      },
      "agent-attorney-individs": {
        query: "getAgentById",
        formDataName: "AgentFormData",
      },
      "foreign-labor": {
        query: "getRecruiterById",
        formDataName: "RecruiterFormData",
      },
      crop: {
        query: "getCropById",
        formDataName: "CropFormData",
      },
      "worker-housing": {
        query: "getWorkerHousingById",
        formDataName: "WorkerHousingFormData",
      },
      agriculture: {
        query: "getAgricultureById",
        formDataName: "AgricultureFormData",
      },
      "material-terms": {
        query: "getMaterialTermsById",
        formDataName: "MaterialTermsFormData",
      },
      "foreign-worker": {
        query: "getForeignWorkerById",
        formDataName: "ForeignWorkerFormData",
      },
      "foreign-worker-group": {
        query: "getForeignWorkerGroupById",
        formDataName: "ForeignWorkerGroupFormData",
      },
    };
    return (
      graphqlnamelist[formName] || {
        query: "getEmployerById",
        formDataName: "EmployerFormData",
      }
    );
  };

  handleSave = (values) => {
    const query = updateQueryBuilder(
      this.props.formName,
      this.props.id,
      this.state.data,
      values
    );

    GQLUtil.genericGQLQuery(query).then(() => {
      this.setState({ modalIsOpen: false, RedirectPage: true });
      this.props.history.push(this.props.location.pathname);
    });
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    const { menuItemStyle, formName, groupId } = this.props;

    const modalStyles = {
      content: {
        width: "100%",
        height: "100%",
        margin: "0",
        padding: "20px",
        position: "absolute",
        borderRadius: "0",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
      },
    };

    const closeButton = {
      position: "absolute",
      right: "20px",
      top: "20px",
      background: "none",
      border: "none",
      padding: 0,
    };

    const closeButtonIcon = {
      height: "40px",
      width: "40px",
    };

    let resolvedUISchema = FormUISchemaResolver(formName);
    let modalUI = HelpfulTipsUIResolver(formName);

    const formStyles = {
      flexBasis: "50%",
    };

    return (
      <Fragment>
        <button
          style={menuItemStyle}
          className="menu-item menu-item-button dropdown-label-View"
          type="button" // This removes default submit
          onClick={this.openModal}
        >
          <span>Edit</span>
        </button>
        <Modal
          style={modalStyles}
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          overlayClassName="Overlay"
        >
          <button style={closeButton} onClick={this.closeModal} type="button">
            <MdClose style={closeButtonIcon} />
          </button>
          <div className="grid-row profile-modal-content">
            <RecoilRoot>
              <SimpleForm
                formStyles={formStyles}
                handleSave={this.handleSave}
                uiSchema={resolvedUISchema}
                inputResolver={inputResolver}
                initialValues={this.state.formData}
                returningToForm={true}
                counties={this.state.counties}
                closeModal={this.closeModal}
                groupId={groupId}
              />
            </RecoilRoot>
            <ModalBox className="helpful-tips-box" {...modalUI} />
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(EditEntityModal);
